import { useState }  from "react";
import { useDispatch, useSelector } from "react-redux";
import { makes as actionsMakes, log as actionsLog } from "../../store/actions";
import ApiMakes from '../../api/makes';
import ListWithControls from "../general/ListWithControls";

const { setSelectedMake, getMakes } = actionsMakes;
const { addToLog } = actionsLog;

const MakesAll = () => {

    let dispatch = useDispatch();

    let selectedMake = useSelector(store => store.makes.selectedMake);
    let items = useSelector(store => store.makes.items);

    const [ makeToRename, setMakeToRename ] = useState(null);

    const selectMake = make => {
        setTimeout(() => {
            dispatch(setSelectedMake(make))    
        }, 0);
    };

    const deleteMake = make => {
        let proceed = window.confirm(`Delete make: ${make.name} [${make.id}]?`);
        if (proceed) {
            ApiMakes.delete(make.id).then(resp => {
                dispatch(getMakes());
                dispatch(addToLog(resp));
                if (selectedMake.id == make.id) {
                    dispatch(setSelectedMake(null));
                }
            });
        }
    }

    const renameMake = (e, make) => {
        e.stopPropagation();
        let proceed = window.confirm(`Rename make: ${make.name} [${make.id}] to ${makeToRename.name}?`);
        if (proceed) {
            ApiMakes.update({ id: make.id, oldName: make.name, newName: makeToRename.name }).then(resp => {
                dispatch(getMakes());
                setMakeToRename(null);
                dispatch(addToLog(resp));
            });
        }
    }

    return (
        <div className="border border-gray-700">
            <div className="text-lg p-2 bg-gray-900">
                All Makes
            </div>
            <ListWithControls 
                items={items} 
                selected={selectedMake} 
                fxSelectItem={selectMake} 
                fxRenameItem={renameMake} 
                fxDeleteItem={deleteMake}
                itemToRename={makeToRename}
                fxSetItemToRename={setMakeToRename} />
        </div>
    );
}

export default MakesAll;